import { createApp } from 'vue';
import {createBootstrap} from 'bootstrap-vue-next';
import App from './App.vue';
import router from './router';

import "@/services/onboard";
import "@/services/eip6963";

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import './assets/main.css';

const app = createApp(App);

app.use(router);
app.use(createBootstrap());
app.mount('#app');
